module.exports = __webpack_public_path__ + "static/media/pp-info-icon.425b26ac.svg";